import React from "react";
import { LayoutDashboard, Zap, CalendarRange, Truck, Users, UserSquare2, CreditCard, History, Settings, Network, ArrowLeftRight, FileSpreadsheet, TrendingDown, FlaskConical, BookMarked } from "lucide-react";
import { SidebarLayout } from "@/components/SidebarLayout";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/jeregul", label: "Jeregul", icon: Zap, testid: "nav-jeregul" },
  { to: "/laregul", label: "Planning", icon: CalendarRange, testid: "nav-laregul" },
  { to: "/corrections", label: "Rétroviseur", icon: History, testid: "nav-corrections" },
  // Tribus Pro & Bourse d'échange masqués (stand-by) — routes conservées, non affichées.
  // { to: "/tribus", label: "Tribus Pro", icon: Network, testid: "nav-protribus" },
  // { to: "/bourse", label: "Bourse d'échange", icon: ArrowLeftRight, testid: "nav-bourse" },
  { to: "/vehicules", label: "Véhicules", icon: Truck, testid: "nav-vehicles" },
  { to: "/conducteurs", label: "Conducteurs", icon: Users, testid: "nav-drivers" },
  { to: "/patients", label: "Patients & Clients", icon: UserSquare2, testid: "nav-patients" },
  { to: "/annuaire", label: "Annuaire médical", icon: BookMarked, testid: "nav-annuaire" },
  { to: "/export", label: "Export & Facturation", icon: FileSpreadsheet, testid: "nav-export" },
  { to: "/statistiques", label: "Statistiques", icon: TrendingDown, testid: "nav-stats" },
  { to: "/test", label: "Générateur de test", icon: FlaskConical, testid: "nav-test" },
  { to: "/abonnement", label: "Abonnement", icon: CreditCard, testid: "nav-billing" },
  { to: "/reglages", label: "Réglages", icon: Settings, testid: "nav-settings" },
];

export function Layout({ children }) {
  const { user } = useAuth();
  const PATH_SECTION = {
    "/": "tableau-de-bord", "/jeregul": "jeregul", "/laregul": "laregul", "/corrections": "corrections",
    "/tribus": "tribus", "/bourse": "bourse", "/vehicules": "vehicules", "/conducteurs": "conducteurs",
    "/patients": "patients", "/annuaire": "annuaire", "/export": "export", "/statistiques": "statistiques", "/test": "test",
    "/abonnement": "abonnement", "/reglages": "reglages",
  };
  const isStaff = !!user?.acting_staff;
  const nav = isStaff ? NAV.filter((n) => (user.allowed_sections || []).includes(PATH_SECTION[n.to])) : NAV;
  return (
    <SidebarLayout nav={nav} title={user?.company_name} subtitle={isStaff ? `${user.acting_staff.name} · accès limité` : user?.email}>
      {children}
    </SidebarLayout>
  );
}
